import {Injectable} from '@angular/core';
import {LoggingPublisherInterface} from "./logging-publisher.interface";
import {LogMessage} from "./log-message";
import {LogLevel} from "./log-level.enum";
import {nonBlank} from "../../libs/utils/epic.utils";


@Injectable({providedIn: 'root'})
export class LoggingPublisherConsoleService implements LoggingPublisherInterface {

  private readonly enabled: boolean = true;

  public isEnabled(): boolean {
    return this.enabled;
  }

  public publish(log: LogMessage): void {
    switch (log.getLevel()) {
      case LogLevel.WARN:
        console.log('%c' + log.buildMessageWithLevel(), 'color: #FFD700;');
        break;
      case LogLevel.ERROR:
        console.log('%c' + log.buildMessageWithLevel(), 'color: #DC143C;');
        if (nonBlank(log.getStack())) {
          console.log(log.getStack());
        }
        break;
      default:
        console.log(log.buildMessageWithLevel());
        break;
    }
  }
}
